import { render, staticRenderFns } from "./AddKYCExceptions.vue?vue&type=template&id=3481fd2f&"
import script from "./AddKYCExceptions.vue?vue&type=script&lang=js&"
export * from "./AddKYCExceptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3481fd2f')) {
      api.createRecord('3481fd2f', component.options)
    } else {
      api.reload('3481fd2f', component.options)
    }
    module.hot.accept("./AddKYCExceptions.vue?vue&type=template&id=3481fd2f&", function () {
      api.rerender('3481fd2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/AddKYCExceptions.vue"
export default component.exports